import { useCSChatBot } from '@zenbusiness/application-commons-cs-chatbot';
import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';
import { WebView } from '@zenbusiness/application-commons-webview';
import Banner from '@zenbusiness/zui/Banner';
import Box from '@zenbusiness/zui/Box';
import PageContainer from '@zenbusiness/zui/PageContainer';
import PageHeader from '@zenbusiness/zui/PageHeader';
import SharedAsset from '@zenbusiness/zui/SharedAsset';

import { ContactMethods } from '#client/components/ContactMethods';
import { ENABLE_HOLIDAY_BANNER } from '#client/constants/experimentsFlags';

const Help = () => {
  const csChatbot = useCSChatBot();
  const enableHolidayBanner = useExperimentFlag(ENABLE_HOLIDAY_BANNER, null);

  if (!WebView?.isWebView) {
    // show chatbot when in help page
    csChatbot.update({ hideDefaultLauncher: false });
  }
  return (
    <PageContainer>
      {enableHolidayBanner?.bannerTitle && (
        <Box mb={4}>
          <Banner
            clickstreamProps={{ appSection: 'home' }}
            data-testid="holiday-banner"
            slots={{
              startIcon: <SharedAsset alt="warning" src="/s2/material-icons/warningamberrounded.svg" />,
            }}
            subtitle={enableHolidayBanner.bannerSubtitle}
            title={enableHolidayBanner.bannerTitle}
            variant="alert"
          />
        </Box>
      )}
      <PageHeader title="Need Help?" subtitle="We are here for you." sx={{ marginBottom: { xs: 4, md: 2 } }} />

      <ContactMethods />
    </PageContainer>
  );
};

export default Help;
